import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import colorArray from "../../helpers/colorArray"
import _ from "lodash"
import { loadingStatus } from "actions"
import { HorizontalBar, Pie } from "react-chartjs-2"
import clone from "clone"
import lineOptions from "helpers/lineOptions"
import axios from "axios"
import settings from "settings"
import numeral from "numeral"
import ImageExport from "components/ImageExport"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"

class Analytics extends Component {
	constructor(props) {
		super(props)
		this.state = {
			hideFlags: {
				ageRange: null,
				city: null,
				region: null,
				source: null,
				gender: null,
				users: null,
				pageviews: null,
				newUsers: null,
				sessions: null,
				bounceRate: null,
				pagesPerSession: null,
				avgSessionDuration: null,
				percentNewUsers: null,
				sessionsPerUser: null,
			},
			data: {
				vanilla: [],
			},
			sorted: {
				pageViews: [],
				referrer: [],
			},
		}
	}

	componentDidMount() {
		this.getData()
	}

	componentDidUpdate(prevProps) {
		if (!_.isEqual(this.props.currentDates, prevProps.currentDates)) {
			this.getData()
		} else if (!_.isEqual(this.props.activeProperties, prevProps.activeProperties)) {
			this.getData()
		}
	}

	getData = () => {
		if (this.props.activeProperties.length == 1) {
			this.props.loadingStatus(true)
			let userToken = localStorage.getItem("user")
			axios
				.post(
					settings.ep + "/getAnalytics",
					{
						property: this.props.activeProperties[0],
						dates: this.props.currentDates,
					},
					{ headers: { Authorization: `Bearer ${userToken}` } }
				)
				.then((resp) => {
					if (resp.data.status == 200) {
						this.setState(
							{
								data: resp.data.analytics,
							},
							() => {
								this.props.loadingStatus(false)
							}
						)
					} else {
						this.props.loadingStatus(false)
					}
				})
		}
	}

	flipPDF = (name, value) => {
		let flags = clone(this.state.hideFlags)
		flags[name] = value
		this.setState({ hideFlags: flags })
	}

	ageRange = () => {
		// First compile a list of all types
		let ret = this.state.data.ageRange
		const data = {
			labels: _.keys(ret),
			datasets: [
				{
					data: _.values(ret),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		return (
			<>
				<ImageExport name="AgeRange" />
				<h3 className="statBox__title">Age Range</h3>
				<div id="ageRange">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	city = () => {
		// First compile a list of all types
		let ret = this.state.data.city
		const data = {
			labels: _.keys(ret),
			datasets: [
				{
					data: _.values(ret),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		return (
			<>
				<ImageExport name="City" />
				<h3 className="statBox__title">City</h3>
				<div id="city">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	region = () => {
		// First compile a list of all types
		let ret = this.state.data.region
		const data = {
			labels: _.keys(ret),
			datasets: [
				{
					data: _.values(ret),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		return (
			<>
				<ImageExport name="Region" />
				<h3 className="statBox__title">Outside States</h3>
				<div id="region">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	sources = () => {
		// First compile a list of all types
		let ret = this.state.data.source
		const data = {
			labels: _.keys(ret),
			datasets: [
				{
					data: _.values(ret),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		return (
			<>
				<ImageExport name="Sources" />
				<h3 className="statBox__title">Sources</h3>
				<div id="city">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	gender = () => {
		// First compile a list of all types
		let ret = this.state.data.gender
		const data = {
			labels: _.keys(ret),
			datasets: [
				{
					data: _.values(ret),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		return (
			<>
				<ImageExport name="Gender" />
				<h3 className="statBox__title">Gender</h3>
				<div id="gender">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	pagePaths = () => {
		// total them first
		let tableData = []
		_.forEach(this.state.data.pagePath, (v, k) => {
			tableData.push({
				path: k,
				totalUsers: v,
			})
		})
		const columns = [
			{
				Header: "Path",
				accessor: "path",
				filterMethod: (f, r) => helpers.tableText(f, r, "path"),
			},
			{
				Header: "Total Users",
				accessor: "totalUsers",
				Footer: (props) => {
					let total = 0
					_.forEach(props.data, (v) => {
						total += v.totalUsers
					})
					if (typeof total == "number") {
						return total.toLocaleString()
					}
					return total
				},
			},
		]

		return (
			<div className="statBox__row" data-html2canvas-ignore={this.state.hideFlags.totalUsers}>
				<div className="statBox__box">
					<ImageExport name="PagePaths" />
					<h3 className="statBox__title">Site Content</h3>
					<FullTable data={tableData} columns={columns} name="siteContent" title="Site Content" />
				</div>
			</div>
		)
	}

	referrer = () => {
		// total them first
		let tableData = []
		_.forEach(this.state.data.referrer, (v, k) => {
			tableData.push({
				path: k,
				pageviews: v,
			})
		})
		const columns = [
			{
				Header: "Path",
				accessor: "path",
				filterMethod: (f, r) => helpers.tableText(f, r, "path"),
			},
			{
				Header: "Page Views",
				accessor: "pageviews",
				Footer: (props) => {
					let total = 0
					_.forEach(props.data, (v) => {
						total += v.pageviews
					})
					if (typeof total == "number") {
						return total.toLocaleString()
					}
					return total
				},
			},
		]

		return (
			<div className="statBox__row" data-html2canvas-ignore={this.state.hideFlags.referrer}>
				<div className="statBox__box">
					<ImageExport name="Referrer" />
					<h3 className="statBox__title">Referrer</h3>
					<FullTable data={tableData} columns={columns} name="referrer" title="Referrer" />
				</div>
			</div>
		)
	}

	vanillaGraph = (type, name, colorIndex) => {
		if (!this.state.data.vanilla[0]) {
			return
		}
		let d = []
		_.forEach(this.state.data.vanilla, (v, k) => {
			let color = colorIndex + k
			d.push({
				label: k == 0 ? "Current Year" : "Previous Year",
				backgroundColor: colorArray[color],
				borderColor: colorArray[color],
				borderWidth: 1,
				data: [v[type]],
			})
		})
		const data = {
			labels: ["Year Over Year"],
			datasets: d,
		}
		lineOptions.scales.yAxes = [
			{
				//display:false
			},
		]
		return (
			<div className="statBox__box" data-html2canvas-ignore={this.state.hideFlags[type]}>
				<ImageExport name={name} />
				<h3 className="statBox__title">{name}</h3>
				<div id={type}>
					<HorizontalBar data={data} options={lineOptions} />
				</div>
			</div>
		)
	}

	yearCont = () => {
		if (this.props.currentDates.endStamp - this.props.currentDates.startStamp > 31556952) {
			return ""
		}
		return (
			<>
				<div className="imageGroup">
					<div className="statBox">
						<h2>Year Over Year</h2>
						<div className="statBox__row statBox__row--double">
							{this.vanillaGraph("users", "Users", 0)}
							{this.vanillaGraph("pageviews", "Pageviews", 2)}
						</div>
						<div className="statBox__row statBox__row--double">
							{this.vanillaGraph("newUsers", "New Users", 4)}
							{this.vanillaGraph("sessions", "Sessions", 6)}
						</div>
						<div className="statBox__row statBox__row--double">
							{this.vanillaGraph("bounceRate", "Bounce Rate", 8)}
							{this.vanillaGraph("pagesPerSession", "Pages Per Session", 10)}
						</div>
					</div>
				</div>
				<div className="imageGroup">
					<div className="statBox">
						<div className="statBox__row statBox__row--double">
							{this.vanillaGraph("avgSessionDuration", "Average Session Duration", 12)}
							{this.vanillaGraph("percentNewUsers", "Percent New Users", 0)}
						</div>
						<div className="statBox__row statBox__row--double">
							{this.vanillaGraph("sessionsPerUser", "Sessions Per User", 2)}
						</div>
					</div>
				</div>
			</>
		)
	}

	render() {
		if (this.props.activeProperties.length == 0 || this.props.activeProperties.length > 1) {
			return (
				<div className="lotStatus__pleaseChoose">
					<h1>Please choose one community to view analytics.</h1>
				</div>
			)
		} else if (this.props.payloadStatus) {
			if (!this.state.data.vanilla) {
				return (
					<div className="lotStatus__pleaseChoose">
						<h1>Property has not been setup for Google Analytics integration.</h1>
					</div>
				)
			}
			return (
				<div className="analytics">
					<div className="imageGroup">
						<Title title="Website Analytics" hideFlags={this.state.hideFlags} />
						<div className="quickStats quickStats--small">
							<ul className="quickStats__list">
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{numeral(
												this.state.data.vanilla[0] && this.state.data.vanilla[0].users
											).format("0,00")}
										</div>
										<div className="quickStats__type">Users</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{this.state.data.vanilla[0] && this.state.data.vanilla[0].percentNewUsers}%
										</div>
										<div className="quickStats__type">Percent New Users</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{numeral(
												this.state.data.vanilla[0] && this.state.data.vanilla[0].sessions
											).format("0,00")}
										</div>
										<div className="quickStats__type">Sessions</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{numeral(
												this.state.data.vanilla[0] && this.state.data.vanilla[0].pageviews
											).format("0,00")}
										</div>
										<div className="quickStats__type">Pageviews</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{numeral(
												this.state.data.vanilla[0] && this.state.data.vanilla[0].bounceRate
											).format("0,00")}
											%
										</div>
										<div className="quickStats__type">Bounce Rate</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{numeral(
												this.state.data.vanilla[0] && this.state.data.vanilla[0].pagesPerSession
											).format("0,00.00")}
										</div>
										<div className="quickStats__type">Pages per Session</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{numeral(
												this.state.data.vanilla[0] &&
													this.state.data.vanilla[0].avgSessionDuration
											).format("0,00.00")}
										</div>
										<div className="quickStats__type">Average Session Duration</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{numeral(
												this.state.data.vanilla[0] && this.state.data.vanilla[0].sessionsPerUser
											).format("0,00.00")}
										</div>
										<div className="quickStats__type">Sessions Per User</div>
									</div>
								</li>
							</ul>
						</div>
						<div className="statBox">
							<div className="statBox__row statBox__row--double">
								<div className="statBox__box avoid" data-html2canvas-ignore={this.state.hideFlags.city}>
									{this.city()}
								</div>
								<div
									className="statBox__box avoid"
									data-html2canvas-ignore={this.state.hideFlags.region}>
									{this.region()}
								</div>
							</div>
						</div>
						<div className="statBox">
							<div className="statBox__row statBox__row--double">
								<div
									className="statBox__box avoid"
									data-html2canvas-ignore={this.state.hideFlags.ageRange}>
									{this.ageRange()}
								</div>
								<div
									className="statBox__box avoid"
									data-html2canvas-ignore={this.state.hideFlags.gender}>
									{this.gender()}
								</div>
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">{this.pagePaths()}</div>
					</div>
					<div className="imageGroup">
						<div className="content">{this.referrer()}</div>
					</div>
					{this.yearCont()}
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(Analytics)
